module.exports = __webpack_public_path__ + "img/user-qr.ba5447ff.png";